import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" ref={ref} {...props}>
        <circle cx={10} cy={10} r={7} fill="currentColor" />
        <mask id="prefix__a" fill="#fff">
            <path
                fillRule="evenodd"
                d="M10 11.776a.68.68 0 0 1-.68-.68V6.11a.68.68 0 0 1 1.36 0v4.985a.68.68 0 0 1-.68.68Z"
                clipRule="evenodd"
            />
            <path d="M9.222 13.889a.778.778 0 1 1 1.556 0 .778.778 0 0 1-1.556 0Z" />
        </mask>
        <path
            fill="#fff"
            fillRule="evenodd"
            d="M10 11.776a.68.68 0 0 1-.68-.68V6.11a.68.68 0 0 1 1.36 0v4.985a.68.68 0 0 1-.68.68Z"
            clipRule="evenodd"
        />
        <path fill="#fff" d="M9.222 13.889a.778.778 0 1 1 1.556 0 .778.778 0 0 1-1.556 0Z" />
        <path
            fill="#fff"
            d="M9.32 11.096H7.57h1.75Zm.68.68v-1.75 1.75Zm-.68-5.665h1.75-1.75Zm1.36 0H8.93h1.75Zm0 4.985h1.75-1.75Zm-1.458 2.793h1.75-1.75Zm.778-.778v-1.75 1.75Zm.778.778h1.75-1.75Zm-.778.778v-1.75 1.75Zm-2.43-3.571a2.43 2.43 0 0 0 2.43 2.43v-3.5c.59 0 1.07.479 1.07 1.07h-3.5Zm0-4.985v4.985h3.5V6.11h-3.5ZM10 3.681a2.43 2.43 0 0 0-2.43 2.43h3.5c0 .59-.48 1.07-1.07 1.07v-3.5Zm2.43 2.43A2.43 2.43 0 0 0 10 3.681v3.5a1.07 1.07 0 0 1-1.07-1.07h3.5Zm0 4.985V6.11h-3.5v4.985h3.5ZM10 13.526a2.43 2.43 0 0 0 2.43-2.43h-3.5c0-.591.48-1.07 1.07-1.07v3.5Zm.972.363a.972.972 0 0 1-.972.972v-3.5a2.528 2.528 0 0 0-2.528 2.528h3.5Zm-.972.972a.972.972 0 0 1-.972-.972h3.5A2.528 2.528 0 0 0 10 11.361v3.5Zm-.972-.972c0-.537.435-.972.972-.972v3.5a2.528 2.528 0 0 0 2.528-2.528h-3.5Zm.972-.972c.537 0 .972.435.972.972h-3.5A2.528 2.528 0 0 0 10 16.417v-3.5Z"
            mask="url(#prefix__a)"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
